import { render, staticRenderFns } from "./DataListCase.vue?vue&type=template&id=3e5c737d"
import script from "./DataListCase.vue?vue&type=script&lang=js"
export * from "./DataListCase.vue?vue&type=script&lang=js"
import style0 from "./DataListCase.vue?vue&type=style&index=0&id=3e5c737d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports